import React, { Component } from 'react'
import { withTranslation } from 'react-i18next';

interface IProps {
    downloadFile: () => void;
    t: any;
};
interface IState{}

class Shared extends Component<IProps, IState> {

    render() {
        const {t} = this.props
        return (
            <div className="flex items-center justify-center">
                <div className="text-center">
                    <img alt="Download" className="mx-auto mt-8 block" height="300" width="300" src="/images/download.png"/>
                    <h2>{t("The file download will start shortly, please wait")}<br/>
                    {t("If your download does not start automatically within 1 minute,")} <span className="text-primary cursor-pointer hover:underline" onClick={() => this.props.downloadFile()}>{t("Click here")}</span></h2>
                </div>
            </div>)
    }
}

export default withTranslation()(Shared as any) as any;
